export default __webpack_public_path__ + "static/media/loader.cdd28b80.gif";